export default "__VITE_ASSET__HQi3iepc__"